import React, { useState, useEffect, useRef } from 'react';
import Header from '../Common_Files/Header';
import Footer from '../Common_Files/Footer';
import config from '../Common_Files/Config';
import ViewSupplier from "../Master/ViewSupplier";
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import generatePDFNew from './CurrentPurchaseOrderInvoice';
import Swal from 'sweetalert2';

const GRN = () => {
  const [draw, setDraw] = useState(1);
  const [start, setStart] = useState(0);
  const [length, setLength] = useState(50);
  const [searchValue, setSearchValue] = useState('');
  const [canSavePartial, setCanSavePartial] = useState(true);
  const modalRef = useRef(null);
  const editModalRef = useRef(null);
  const tableRef = useRef(null);
  const accessToken = localStorage.getItem('accessToken');
  const handleGeneratePDF = (id) => {
    generatePDFNew(id);
  };

  const handleViewPOInvoice = (id) => {
    generatePDFNew(id, true, 'P.O Invoice');
  };

  const handleDownloadPOInvoice = (id) => {
    generatePDFNew(id, false, 'P.O Invoice');
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    });

    if (result.isConfirmed) {
      try {
        const formData = new FormData();
        formData.append('purchase_id', id);

        const response = await fetch(`${config.api_url}/ws-delete-grn`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${accessToken}`
          },
          body: formData
        });

        if (response.ok) {
          Swal.fire(
            'Deleted!',
            'GRN has been deleted successfully.',
            'success'
          );
          // Refresh the data table
          if (tableRef.current && $.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().ajax.reload();
          }
        } else {
          throw new Error('Failed to delete GRN');
        }
      } catch (error) {
        Swal.fire(
          'Error!',
          'Failed to delete GRN. Please try again.',
          'error'
        );
      }
    }
  };
  const initializeDataTable = () => {
    const $table = $(tableRef.current);

    if ($.fn.DataTable.isDataTable($table)) {
      $table.DataTable().destroy();
    }

    $table.DataTable({
      processing: true,
      serverSide: true,
      ordering: false,
      ajax: {
        url: `${config.api_url}/ws-grn-list`,
        type: 'POST',
        data: function (d) {
          return $.extend({}, d, {
            draw: d.draw,
            start: d.start,
            length: d.length,
            searchValue: searchValue
          });
        },
        dataSrc: function (json) {
          return json.data;
        }
      },
      language: {
        paginate: {
          first: 'First',
          last: 'Last',
          next: 'Next',
          previous: 'Previous',
        },
        search: 'Search:',
      },
      columns: [
        { data: 'created_date', width: "6%" },
        {
          data: 'reference_no', width: '10%',
        },
        {
          data: 'name',
          render: function (data, type, row) {
            return `<a href="#" class="view-supplier" data-bs-toggle="modal" data-bs-target="#viewsupplier" title="View Supplier" data-id="${row.supplier_id}">${data}</a>`;
          }
        },
        {
          data: null,
          width: "7%",
          className: 'dt-type-numeric',
          render: function (data, type, row) {
            const grandTotal = parseFloat(row.grand_total) || 0;
            const vatAmount = parseFloat(row.vat_amount) || 0;
            return (grandTotal - vatAmount).toFixed(2);
          }
        },
        { data: 'vat_amount', width: "7%", className: 'dt-type-numeric' },
        { data: 'grand_total', width: "7%", className: 'dt-type-numeric' },
        { data: 'status', width: "7%" },
        {
          data: null,
          width: "15%",
          render: (data, type, row) => {
            let grnIcon = '';

            if (row.status === "Partial") {
              grnIcon = `<a href="/editNewPurchaseOrder/${row.id}" title="View">
                   <i class="fa fa-eye"></i>
                 </a>`;
            } else {
              grnIcon = `<a href="/editNewPurchaseOrder/${row.id}" title="Edit">
                   <i class="fa fa-edit"></i>
                 </a>`;

            }

            return `
      ${grnIcon}
      <a href="/ConfirmGRN/${row.id}" title="GRN">
                   <i class="fa fa-truck"></i>
                 </a>             
      <a href="#" class="generate-pdf" data-id="${row.id}" title="Collection note">
        <i class="fa fa-download"></i>
      </a>
           <a href="#" class="download-po-invoice" data-id="${row.id}" title=" P.O Invoice">
        <i class="fa fa-file-text"></i>
      </a>
      <a href="#" class="delete-grn" data-id="${row.id}" title="Delete">
        <i class="fa fa-trash"></i>
      </a>
    `;
          }
        }

      ],
      columnDefs: [{ orderable: false, targets: '_all' }],
      pageLength: 10,
    });

    $table.on('click', '.generate-pdf', function (e) {
      e.preventDefault();
      const id = $(this).data('id');
      handleGeneratePDF(id);
    });

    $table.on('click', '.view-po-invoice', function (e) {
      e.preventDefault();
      const id = $(this).data('id');
      handleViewPOInvoice(id);
    });

    $table.on('click', '.download-po-invoice', function (e) {
      e.preventDefault();
      const id = $(this).data('id');
      handleDownloadPOInvoice(id);
    });

    $table.on('click', '.delete-grn', function (e) {
      e.preventDefault();
      const id = $(this).data('id');
      handleDelete(id);
    });
  };


  useEffect(() => {
    if (!accessToken) {
      window.location.href = '/login';
      return;
    }
    initializeDataTable();

    return () => {
      if (tableRef.current && $.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
    };
  }, [searchValue]);

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };



  return (
    <div>
      <Header />
      <ViewSupplier />
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <a href="#"><i className="fa fa-home"></i></a> &gt;
              <a href="/dashboard">Dashboard</a> &gt;
              <span className="last-crumb">Current Purchase Order</span>
            </div>
          </div>
        </div>
      </div>
      <div className="main-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <div className="dashboard">
                <div className='topsearch-area'>
                  <div className="row">
                    <div className="col-12 col-lg-4 col-sm-4">
                      <div className="row">
                        <label htmlFor="inputText" className="col-sm-5 col-form-label">P.O ID/Supplier</label>
                        <div className="col-sm-6">
                          <input
                            type="text"
                            className="search-area"
                            placeholder="Search"
                            autoComplete="off"
                            value={searchValue}
                            onChange={handleSearchChange}

                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="verical-scrl-wrapper common-table grn-tbl" id="style-3">
                <table className="table table-bordered dataTable" id="dsTable" ref={tableRef}>
                  <thead>
                    <tr>
                      <th>Raised On</th>
                      <th>P.O ID</th>
                      <th>Supplier(ID)</th>
                      <th>Order Amount</th>
                      <th>VAT</th>
                      <th>Total</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody></tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default GRN;
